module.exports = __webpack_public_path__ + "static/media/indonesia.390700f7.png";